import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ToastHelper } from "@/helpers/ToastHelper";

@Component({
    name: "take-pictures",
})

export default class TakePictures extends Vue {
    // 1 : ReceptionValidation
    // 2 : ExpeditionAutoControl
    // 3 : ExpeditionEndLoad
    @Prop({ required: true, type: Number })
    public type: number;

    @Prop({ required: true })
    public pictures: string[];

    public video: any;
    public canvas: any;

    public constructor() {
        super();
    }

    public mounted(): void {
        this.video = this.$refs.video;

        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
                this.video.srcObject = stream;
                this.video.play();
            }).catch(reason => {
                ToastHelper.general.noCamera();
            });
        }
    }

    public capture(): void {
        this.canvas = this.$refs.canvas;
        const context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 640, 480);

        switch (this.type) {
            case 1:
                this.$store.dispatch("receptions/addValidationPicture", this.canvas.toDataURL("image/png"));
                break;
            case 2:
                this.$store.dispatch("expeditions/addAutoControlPicture", this.canvas.toDataURL("image/png"));
                break;
            case 3:
                this.$store.dispatch("expeditions/addEndLoadPicture", this.canvas.toDataURL("image/png"));
                break;
        }
    }

    public validate(): void {
        this.stopRecording();

        this.$parent.$data.isTakingPictures = false;
    }

    public cancel() {
        this.stopRecording();

        this.$parent.$data.isTakingPictures = false;
    }

    public removePicture(index: number) {
        switch (this.type) {
            case 1:
                this.$store.dispatch("receptions/removeValidationPicture", index);
                break;
            case 2:
                this.$store.dispatch("expeditions/removeAutoControlPicture", index);
                break;
            case 3:
                this.$store.dispatch("expeditions/removeEndLoadPicture", index);
                break;
        }
    }

    private stopRecording() {
        const stream = this.video.srcObject;

        if (stream) {
            const tracks = stream.getTracks();

            tracks.forEach((track) => {
                track.stop();
            });
            this.video.srcObject = null;
        }
    }
}
